import { Mutator } from 'final-form';

import { FormValues } from './types';

export const addGroup: Mutator<FormValues> = (_, state, utils) => {
  utils.changeValue(state, 'user_groups', (prev) => [...prev, null]);
};

export const deleteGroup: Mutator<FormValues> = (args, state, utils) => {
  const [orderNumber] = args;
  utils.changeValue(state, 'user_groups', (prev) => {
    return prev.filter((_: string, index: number) => index !== orderNumber);
  });
};
